import type { StatusTone } from '../../../ui-kit';
import type { PcCheckCard, PcSeverity } from '../../../services/policyCheckingService';

/** The chip a check wears in the list and at the top of its own page. */
export function resultChip(check: Pick<PcCheckCard, 'status' | 'result' | 'stage'>): {
  tone: StatusTone; label: string; pulse?: boolean;
} {
  if (check.status === 'reading') return { tone: 'neutral', label: 'Reading the documents', pulse: true };
  if (check.status === 'failed') return { tone: 'bad', label: 'Could not be read' };
  switch (check.result) {
    case 'must_fix': return { tone: 'bad', label: 'Must fix' };
    case 'review': return { tone: 'warning', label: 'Review' };
    default: return { tone: 'good', label: 'All clear' };
  }
}

/** The chip one finding wears. */
export const SEVERITY: Record<PcSeverity, { tone: StatusTone; label: string }> = {
  must_fix: { tone: 'bad', label: 'Must fix' },
  review: { tone: 'warning', label: 'Review' },
  match: { tone: 'good', label: 'Matches' },
};

/** "1.2 MB", "840 KB". */
export function sizeOf(bytes: number): string {
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
}

/** "$1,016,063". */
export const money = (value: number | null | undefined): string =>
  value == null ? '—' : `$${Math.round(value).toLocaleString()}`;
